import { render, staticRenderFns } from "./QueueInformation.vue?vue&type=template&id=5484f069&scoped=true&"
import script from "./QueueInformation.vue?vue&type=script&lang=js&"
export * from "./QueueInformation.vue?vue&type=script&lang=js&"
import style0 from "./QueueInformation.vue?vue&type=style&index=0&id=5484f069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484f069",
  null
  
)

export default component.exports